import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './PatternView.module.css';

const PatternView = () => {
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlotProducts = useSelector(state => state.visualizer.selectedSlotProducts);
    const [isLoading, setIsLoading] = useState(false);
    const [currentImageUrl, setCurrentImageUrl] = useState(null);
    
    // Generate the sel parameter based on selected products
    const generateSelParameter = () => {
        if (!activePattern || !activePattern.descriptor) {
            return '-1';
        }
        
        // Get color slots from descriptor
        const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
        
        // Build the sel parameter with just product IDs
        const selParts = [];
        colorSlots.forEach((slot, index) => {
            const product = selectedSlotProducts[index];
            if (product && product.id) {
                selParts.push(product.id);
            } else {
                selParts.push('-1');
            }
        });
        
        return selParts.join(',');
    };
    
    // Generate the image URL using the pattern's description and selected products
    const getPatternImageUrl = () => {
        if (!activePattern || !activePattern.description) {
            return null;
        }
        
        const selParameter = generateSelParameter();
        
        return `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=!${encodeURIComponent(activePattern.description)}&sel=${selParameter}&size=1024&extra=(DESIGN=(MODEL=TILE),focus=(@size[x]/@res[x]/1in),size=(?,(@size[x]*@res[y]/@res[x])))`;
    };

    // Update image URL when pattern or products change
    useEffect(() => {
        const newImageUrl = getPatternImageUrl();
        if (newImageUrl && newImageUrl !== currentImageUrl) {
            setIsLoading(true);
            setCurrentImageUrl(newImageUrl);
        }
    }, [activePattern, selectedSlotProducts]);

    // Handle image load completion
    const handleImageLoad = () => {
        setIsLoading(false);
    };

    // Handle image load error
    const handleImageError = () => {
        setIsLoading(false);
    };

    if (!currentImageUrl) {
        return (
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <div className={styles.placeholder}>
                        No pattern selected
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.content}>
            <div className={styles.imageContainer}>
                {isLoading && (
                    <div className={styles.loadingOverlay}>
                        <div className={styles.spinner}></div>
                        <div className={styles.loadingText}>Updating preview...</div>
                    </div>
                )}
                <img 
                    src={currentImageUrl} 
                    alt={`Pattern: ${activePattern.name || activePattern.patternName || 'Pattern View'}`}
                    className={`${styles.patternImage} ${isLoading ? styles.loading : ''}`}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                />
            </div>
        </div>
    );
};

export default PatternView;